import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryLoanInstalmentsTable  {
    _originalTypeClassName = "zERP.BO.SalaryLoanInstalmentsTable";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryLoanInstalmentsTable.translate = translateService;
}
this.EmployeeSalaryLoanInstalment = [];
this.SalaryLoanInstalmentsTableKey = null;
this._key = this.SalaryLoanInstalmentsTableKey = 0; 
}

static translate: TranslateService;
_key: any;
PayrollPeriod:any;
SalaryPeriod:any;
EmployeeSalaryLoanInstalment:any;
private _SalaryLoanInstalmentsTableKey:any;
get SalaryLoanInstalmentsTableKey(): any {
    return this._SalaryLoanInstalmentsTableKey;
  }
set SalaryLoanInstalmentsTableKey(value: any) {
    this._SalaryLoanInstalmentsTableKey = value;
    this._key = value;
  }
static setPayrollPeriod = ($this, value) => {
var oldValue = $this.PayrollPeriod;
$this.PayrollPeriod = value;
if (value != null) {
}
}
static setSalaryPeriod = ($this, value) => {
var oldValue = $this.SalaryPeriod;
$this.SalaryPeriod = value;
if (value != null) {
}
}
static setEmployeeSalaryLoanInstalment = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmployeeSalaryLoanInstalment == null) $this.EmployeeSalaryLoanInstalment = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmployeeSalaryLoanInstalment.length > 0) {
                    Domain.SalaryLoanInstalmentsTable.removeEmployeeSalaryLoanInstalment($this, $this.EmployeeSalaryLoanInstalment[0]);
                }

                Domain.SalaryLoanInstalmentsTable.addManyEmployeeSalaryLoanInstalment($this, copyItems);
            }
static addManyEmployeeSalaryLoanInstalment = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SalaryLoanInstalmentsTable.addEmployeeSalaryLoanInstalment($this, items[i]);
                }
            }
static addEmployeeSalaryLoanInstalment = ($this, item) => {
                if ($this.EmployeeSalaryLoanInstalment == null) $this.EmployeeSalaryLoanInstalment = [];
                if (item == null || $this.EmployeeSalaryLoanInstalment.indexOf(item) > -1) return;
                $this.EmployeeSalaryLoanInstalment.push(item);
}
static addRangeEmployeeSalaryLoanInstalment = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SalaryLoanInstalmentsTable.addEmployeeSalaryLoanInstalment($this, item));
            }
static removeEmployeeSalaryLoanInstalment = ($this, item) => {
                if ($this == null || $this.EmployeeSalaryLoanInstalment == null || $this.EmployeeSalaryLoanInstalment.indexOf(item) === -1) return;
                var _index = $this.EmployeeSalaryLoanInstalment.indexOf(item);
                $this.EmployeeSalaryLoanInstalment.splice(_index, 1);
}
static clearEmployeeSalaryLoanInstalment = ($this) => { $this.EmployeeSalaryLoanInstalment = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SalaryLoanInstalmentsTableKey == null || $this.SalaryLoanInstalmentsTableKey == 0;
            }


}